export default __webpack_public_path__ + "static/media/Level_two.6de30f7f.svg";